﻿import { DiagramCookieSet, DiagramCookieRead, DiagramCookieClear } from '@/modules/Diagram.Cookies.js'

export async function DiagramAlertBanner() {

    //Load banners that haven't been dismissed and un-hide them
    document.querySelectorAll('.alert-banners-wrapper .banner').forEach((item) => {
        const bannerId = 'banner-' + item.getAttribute('data-key');

        if (!DiagramCookieRead(bannerId)) {
            item.classList.add('is-active')
        } else {
            item.setAttribute('aria-hidden', 'true');
        } 

        document.querySelector('.alert-banners-wrapper').classList.remove('is-loading');
        
    }) 

    //Closable banners - dismiss and hide
    document.querySelectorAll('.alert-close').forEach((item) => {
        const parent = item.parentNode.parentNode;
        const bannerId = 'banner-' + parent.getAttribute('data-key');

        //set height of banners for animation
        function setParentHeight() {
            parent.removeAttribute('style');
            parent.style.height = parent.offsetHeight + 'px';
        }
        setParentHeight();
        window.addEventListener('resize', setParentHeight);
        

        //To do on close
        function onClose() {
            DiagramCookieSet(bannerId, true, 1); // omit 3rd parameter for session cookie
            parent.setAttribute('aria-hidden', 'true');
            parent.classList.add('dismissed');
            return false;
        }

        // hide banners when close button is clicked
        item.addEventListener('click', function () {
            onClose();
        })

        // hide banners when enter key is pushed
        item.addEventListener('keypress', function (event) {
            if (event.key === 'Enter') {
                onClose();
            }
        })
    })

    //Keep emergency banners stuck at top on desktop
    const emergencyBanners = document.querySelector('.emergency-alerts');
    const stickyHeader = document.querySelector('.site-header.sticky-header');
    const alertWrapper = document.querySelector('.alert-banners-wrapper');

    function stickyEmergencies() {
        emergencyBanners.removeAttribute('style');
        let x = window.matchMedia("(min-width: 56rem)");
        let emergencyBannersHeight = emergencyBanners.offsetHeight + 'px';

        if (x.matches) {
            emergencyBanners.style.height = emergencyBannersHeight;
            stickyHeader.style.marginTop = emergencyBannersHeight;
            alertWrapper.style.paddingTop = emergencyBannersHeight;
        } else {
            emergencyBanners.removeAttribute('style');
            stickyHeader.removeAttribute('style');
            alertWrapper.removeAttribute('style');
        }
    }
    if (emergencyBanners != null) {
        stickyEmergencies();

        // debounced resize for performance
        let timeout = false;
        window.addEventListener('resize', function () {
            clearTimeout(timeout);
            timeout = setTimeout(stickyEmergencies, 125);
        });
    }
}


